import { SvgIconType } from './svg.interface';

const CriticalCircle: SvgIconType = ({
  width = 16,
  height = 16,
  className = '',
  color = '#DF1B1B'
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 -3.13124e-07 8 -6.99382e-07C3.58172 -1.08564e-06 -3.13124e-07 3.58172 -6.99382e-07 8C-1.08564e-06 12.4183 3.58172 16 8 16ZM11.4765 12.8907L3.10925 4.52346C2.41079 5.50428 2 6.70417 2 8C2 11.3137 4.68629 14 8 14C9.29583 14 10.4957 13.5892 11.4765 12.8907ZM14 8C14 9.29583 13.5892 10.4957 12.8907 11.4765L4.52347 3.10925C5.50428 2.41079 6.70417 2 8 2C11.3137 2 14 4.68629 14 8Z"
      fill={color}
    />
  </svg>
);

export default CriticalCircle;
